import { useMemo } from 'react';
import dialCodes from '../dial-codes';

const dialCodesByLocale = {
  en: '001',
  nl: '0031',
  fr: '0033',
  de: '0049',
  it: '0039',
  es: '0034',
};

export const defaultDialCode = (locale: string) => {
  const navigatorLanguages = [...navigator.languages].reverse();

  // Loop through the browser locales, the browser has for example: ["en-US", "en", "nl"]
  for (let i = 0; i < navigatorLanguages.length; i += 1) {
    const language = navigatorLanguages[i];

    const shortLocale = language.slice(0, 2);

    // If the locale matches a preset, use that dial code
    if (shortLocale in dialCodesByLocale) {
      return dialCodesByLocale[shortLocale as keyof typeof dialCodesByLocale];
    }
  }

  // Use the SDK locale as fallback
  if (locale) {
    if (locale in dialCodesByLocale) {
      return dialCodesByLocale[locale as keyof typeof dialCodesByLocale];
    }
  }

  // Fallback to USA
  return '(+1)';
};

export default function useDialOptions() {
  const options = useMemo(() => {
    return Object.entries(dialCodes).map(([country, dialCode]) => {
      return {
        label: country.toUpperCase(),
        value: dialCode,
      };
    });
  }, []);

  return {
    options,
  };
}
